module.exports = __webpack_public_path__ + "static/che11-2e5580fc189d23925bae853d1fd452e6.jpg";